import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { injectIntl, FormattedMessage } from 'react-intl'
import { compose, pure } from 'recompose'

import { Input, Textarea, Checkbox, Select } from 'components/fields'
import {
  mapActivitiesParents,
  mapActivitiesCategories
} from 'redux/selectors/activities'
import { ACTIVITY_CATEGORIES, PROGRESS_STATES } from 'constants/enums'

const enhance = compose(pure, injectIntl)

class ActivityDetail extends Component {
  static propTypes = {
    section: PropTypes.string.isRequired,
    initialize: PropTypes.func.isRequired,
    values: PropTypes.object,
    data: PropTypes.object,
    intl: PropTypes.object,
    activities: PropTypes.object.isRequired,
    noTitle: PropTypes.bool,
    validateMajorChange: PropTypes.func,
    isAssessorDetailMandatory: PropTypes.bool,
    isAssessorManagementEnabled: PropTypes.bool,
    activityState: PropTypes.object.isRequired,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func.isRequired,
    orgId: PropTypes.number.isRequired,
    change: PropTypes.func.isRequired,
    assessorList: PropTypes.array
  }

  componentWillMount = () => {
    const { data, values, onGetAvailableAssessorsForActivityCategory, isAssessorManagementEnabled, subCategoryId, orgId } = this.props

    let newData = { ...data }

    if (get(values, 'activityCategory.userDefined')) {
      newData = { ...newData, ...this.getOtherCategory(values) }
    }
    if (isAssessorManagementEnabled) {
      if (subCategoryId && subCategoryId !== ACTIVITY_CATEGORIES.other.id && orgId) {
        onGetAvailableAssessorsForActivityCategory(orgId, subCategoryId)
      }
    }
    if (get(data, 'assessor.id')) {
      const newAssessorId = get(data, 'assessor.id') ?? 0

      newData = { ...newData, setupAssessorId: newAssessorId }
    }

    // run after all other events
    setTimeout(() => {
      this.props.initialize(newData)
    }, 0)
  }

  componentWillReceiveProps = nextProps => {
    const { values, data, isAssessorManagementEnabled } = this.props

    let newData = { ...(get(nextProps, 'data') ?? {}) }

    let needReinitialize = false

    if (
      get(values, 'activityCategory.id') !==
      get(nextProps.values, 'activityCategory.id') &&
      get(nextProps.values, 'activityCategory.userDefined')
    ) {
      newData = { ...newData, ...this.getOtherCategory(nextProps.values) }
      needReinitialize = true
    }

    if (get(data, 'assessor.id') !== get(nextProps, 'data.assessor.id') && get(nextProps, 'data.assessor.id')) {
      const newAssessorId = get(nextProps, 'data.assessor.id') ?? 0

      newData = { ...newData, setupAssessorId: newAssessorId }
      needReinitialize = true
    }
    if (needReinitialize) {
      nextProps.initialize(newData)
    }

    if (
        (get(values, 'activityCategory.id') !== get(nextProps.values, 'activityCategory.id')) && isAssessorManagementEnabled
    ) {
      const orgId = get(nextProps, 'orgId')
      const subCategoryId = get(nextProps.values, 'activityCategory.id')

      orgId && subCategoryId && subCategoryId !== ACTIVITY_CATEGORIES.other.id && this.props.onGetAvailableAssessorsForActivityCategory(orgId, subCategoryId)
    }
  }

  getOtherCategory = values => {
    const { data } = this.props

    return {
      otherName: get(values, 'activityCategory.name'),
      activityCategory: {
        ...data.activityCategory,
        id: ACTIVITY_CATEGORIES.other.id,
        userDefined: false,
        name: get(values, 'activityCategory.name')
      }
    }
  }

  clearAssessorInfo = () => {
    const { data } = this.props

    const assessorId = get(data, 'assessor.id') ?? 0
    const isCustomAssessor = (assessorId === 0)

    this.props.change('assessorTitle', isCustomAssessor ? get(data, 'assessorTitle') : null)
    this.props.change('assessorName', isCustomAssessor ? get(data, 'assessorName') : null)
    this.props.change('assessorEmail', isCustomAssessor ? get(data, 'assessorEmail') : null)
    this.props.change('assessorPhone', isCustomAssessor ? get(data, 'assessorPhone') : null)
    this.props.change('assessorRelevantExperience', isCustomAssessor ? get(data, 'assessorRelevantExperience') : null)
  }

  handleCategoryChange = () => {
    this.props.change('activityCategory.id', null)
  }

  handleSubCategoryChange = subCategoryId => {
    const { onGetAvailableAssessorsForActivityCategory, isAssessorManagementEnabled, orgId } = this.props

    if (isAssessorManagementEnabled && subCategoryId && subCategoryId !== ACTIVITY_CATEGORIES.other.id && orgId) {
      onGetAvailableAssessorsForActivityCategory(orgId, subCategoryId)
    }

    this.clearAssessorInfo()
  }

  handleAssessorChange = () => {
    this.clearAssessorInfo()
  }

  render() {
    const {
      activities,
      values,
      section,
      intl,
      noTitle,
      validateMajorChange,
      isAssessorDetailMandatory,
      activityState,
      isAssessorManagementEnabled,
      data,
      assessorList
    } = this.props

    const parentId = get(values, 'activityCategory.parent.id')

    const mappedParents = mapActivitiesParents(activities.parents, section)

    const subcategoryValue = get(values, 'activityCategory.id')

    const assessor = get(data, 'assessor')

    const isAssessorSetup = get(values, 'setupAssessorId')

    const isOthersSubCategory = ACTIVITY_CATEGORIES.other.id === subcategoryValue

    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0 || assessor === null

    const showAssessorForm = (!isAssessorManagementEnabled || (isNoneOfTheseSubCategory && subcategoryValue && !isAssessorSetup)) || isOthersSubCategory

    const mappedCategories = mapActivitiesCategories(
      activities.list,
      parentId,
      intl.formatMessage({
        id: 'label.other',
        defaultMessage: 'Other'
      })
    )

    const forbiddenActivityStates = [
      PROGRESS_STATES.activityInProgress.id,
      PROGRESS_STATES.activityAssessment.id,
      PROGRESS_STATES.activityLeaderSignoff.id,
      PROGRESS_STATES.activityComplete.id,
      PROGRESS_STATES.activityCeremony.id,
      PROGRESS_STATES.activityInactive.id,
      PROGRESS_STATES.activityDeleted.id,
      PROGRESS_STATES.approvementState.id
    ]

    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            {!noTitle &&
            <h2>
              <FormattedMessage
                id="moduleTitle.activity_detail"
                defaultMessage="Activity Detail"
              />
            </h2>}
            <Select
              label="Activity Type"
              intlKey="label.activity_type"
              name="activityCategory.parent.id"
              options={mappedParents}
              searchable
              sorted
              onInputChange={subCategoryId => this.handleCategoryChange(get(subCategoryId, 'value'))}
            />
            <Select
              label="Activity"
              intlKey="label.activity"
              name="activityCategory.id"
              options={mappedCategories}
              sorted
              onInputChange={subCategoryId => this.handleSubCategoryChange(get(subCategoryId, 'value'))}
            />
            {isOthersSubCategory &&
            <Input
              label="Other activity"
              intlKey="label.other_activity"
              name="activityCategory.name"
              maxLength={512}
            />}
            <Textarea label="Aim" intlKey="label.aim" name="aim" />
            <Checkbox label="Major" intlKey="label.major" name="isMajor"
                      validateChange={validateMajorChange} />
          </div>
        </div>

        {(((isAssessorDetailMandatory || isAssessorManagementEnabled) && !forbiddenActivityStates.includes(get(activityState, 'value')))) && <div className="row">
          <div className="col-xs-12" id='assessorAnchor'>

            <h2>
              <FormattedMessage
                  id="moduleTitle.assessor_details"
                  defaultMessage="Assessor Details"
              />
            </h2>
              {isAssessorManagementEnabled && !isOthersSubCategory && !forbiddenActivityStates.includes(get(activityState, 'value')) && <div className="row">
                <div className="col-xs-12">
                  <Select
                      name="setupAssessorId"
                      label=""
                      intlKey=""
                      options={assessorList}
                      disabled={!subcategoryValue || isOthersSubCategory}
                      onInputChange={() => this.handleAssessorChange()}
                  />
                </div>
              </div>}

            {showAssessorForm && <div>
            <Input label="Title" intlKey="label.title" name="assessorTitle" />
            <Input label="Name" intlKey="label.name" name="assessorName" />
            <Input label="Email" intlKey="label.email" name="assessorEmail" />
            <Input label="Phone" intlKey="label.phone" name="assessorPhone" />
              </div>}
          </div>


        </div>}
      </div>
    )
  }
}

export default enhance(ActivityDetail)
